import React from 'react';
import ReactDOM from 'react-dom/client';
import Path from './path';
import './root.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Path />
  </React.StrictMode>
);